export default __webpack_public_path__ + "static/media/google-sheets.554af47d.svg";